
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your Firebase web config (Console → Project settings → Web)
// This object is safe to expose in a web app.
const firebaseConfig = {
  apiKey: "AIzaSyDhig1s0P5iIOLKAKsRwb0-PZZnZ3LVZAk",
  authDomain: "sbgo-61b2f.firebaseapp.com",
  projectId: "sbgo-61b2f",
  storageBucket: "sbgo-61b2f.firebasestorage.app",
  messagingSenderId: "790020866307",
  appId: "1:790020866307:web:0d3f3268b5fea69dc7a936"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
